import { Text, Button, Image, LinkBase } from '@belong/ui';
import { LEASE_SIGNING_FLOW_STRINGS } from 'lease-signing-flow-v2/constants/strings';
import AgreementFlowFormLayout from 'pages/AgreementFlow/AgreementFlowFormLayout/AgreementFlowFormLayout';
import { getString } from 'strings';

type Props = {
  handleSubmit: (values?: any) => void;
  handleDownload: () => void;
  residents: any;
  [key: string]: any;
};

export function SeattleSignStep({
  handleSubmit,
  handleDownload,
  residents,
  ...rest
}: Props) {
  return (
    <AgreementFlowFormLayout
      {...rest}
      onSubmit={handleSubmit}
      title={LEASE_SIGNING_FLOW_STRINGS['sign.notarize']}
      subTitle={LEASE_SIGNING_FLOW_STRINGS['sign.notarizeSubtitle']}
      initialValues={{}}
      ctaProps={{ label: LEASE_SIGNING_FLOW_STRINGS['sign.soundsGood'] }}
      getForm={() => {
        return (
          <div className="mt-xl rounded border border-solid border-gray bg-light-gray p-sm">
            <Text fontWeight="semibold" variant="h3">
              {LEASE_SIGNING_FLOW_STRINGS['sign.whatsNext']}
            </Text>
            <ol className="my-sm pl-sm">
              <li>{LEASE_SIGNING_FLOW_STRINGS['sign.notarize.step1']}</li>
              <li>{LEASE_SIGNING_FLOW_STRINGS['sign.notarize.step2']}</li>
              <li>
                {getString(LEASE_SIGNING_FLOW_STRINGS['sign.notarize.step3'], {
                  count: residents === 1 ? 'you' : `all ${residents} of you`,
                })}
              </li>
            </ol>
            <div className="flex flex-col items-start justify-between lg:flex-row lg:items-center">
              <div className="flex flex-col items-start gap-2xs lg:flex-row">
                <Text>{LEASE_SIGNING_FLOW_STRINGS['sign.forReference']}</Text>
                <Button variant="text" onClick={handleDownload}>
                  {LEASE_SIGNING_FLOW_STRINGS['sign.downloadLease']}
                </Button>
              </div>
              <LinkBase
                className="mt-sm self-end lg:mt-0"
                style={{ width: 100 }}
                href="https://www.notarize.com"
                target="_blank"
              >
                <Image
                  src="/lease-signing-flow/powered-by-notarize.svg"
                  alt="notarize"
                />
              </LinkBase>
            </div>
          </div>
        );
      }}
    />
  );
}
